<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner">
      @if (
        !data.readOnly ||
        (data.readOnly &&
          (question().structure.description || fileList.length === 0))
      ) {
        <lib-input-container
          [headLine]="
            question().translations?.list['headLine']
              | translate: data.activeLang : question().structure.headLine
          "
          [fileOrEndDateDescription]="
            question().translations?.list['description']
              | translate: data.activeLang : question().structure.description
          "
          [labelPrefix]="questionNumber$ | async"
          [label]="
            question().translations?.list['title']
              | translate: data.activeLang : question().title
          "
          [questionMarkText]="
            question().translations?.list['questionMarkText']
              | translate
                : data.activeLang
                : question().structure.questionMarkText
          "
          [required]="question().validation.required"
          [for]="labelPrefix() + question().id"
          [helpText]="
            question().translations?.list['helpText']
              | translate: data.activeLang : question().structure.helpText
          "
        >
          @if ((data.readOnly && fileList.length === 0) || !data.readOnly) {
            <lib-file-upload
              [id]="labelPrefix() + question().id"
              [disabled]="
                isUploadDisabled || (!!data.readOnly && fileList.length === 0)
              "
              [error]="
                (data.readOnly !== ReadonlyState.Reader && isInvalid()) ||
                (data.readOnly === ReadonlyState.Locked &&
                  fileList.length === 0 &&
                  question().validation.required) ||
                error()
              "
              [readonly]="data.readOnly"
              [uploadedFiles]="fileList"
              [required]="required"
              [allowedFileTypes]="allowedFileTypes()"
              [maxNumberOfFiles]="maxNumberOfFiles"
              [maxNumberOfPages]="maxNumberOfPages"
              [isUpdatingAnswer]="rendererFormRepository.isLoading$ | async"
              [maxFileSize]="maxFileSize"
              [changedFileIds]="
                showChanges()
                  ? previousAnswersService.getChangedFileUploadIds(
                      question().id,
                      repeaterGroupId(),
                      valueFormControl().value ?? []
                    )
                  : []
              "
              (upload)="uploadFiles($event)"
              (download)="downloadFile($event)"
              (remove)="removeFile($event)"
              (fileWindow)="fileWindow($event)"
            ></lib-file-upload>
          }
        </lib-input-container>
      }
      @if (data.readOnly) {
        @if (
          data.readOnly &&
          question().structure.description &&
          fileList.length > 0
        ) {
          <div class="readonly description-break-line"></div>
        }
        @for (file of valueFormControl().value; track $index) {
          <div class="readonly d-flex align-items-center">
            <button
              type="button"
              class="btn link-btn d-flex"
              (click)="downloadFile(file)"
            >
              <lib-icon name="file-text" class="description-icon"></lib-icon>
              <strong class="file-name"
                >{{
                  file.pdfFileName.replace('_', '-').slice(0, -4) +
                    '-' +
                    file.originalFileName.slice(
                      0,
                      file.originalFileName.lastIndexOf('.')
                    )
                }}
              </strong>
            </button>
            <div class="file-info">
              <span
                >({{
                  file.originalFileName.slice(
                    file.originalFileName.lastIndexOf('.') -
                      file.originalFileName.length +
                      1
                  )
                }}</span
              >
              <span
                >,
                {{
                  file.fileSize ? math.round(file?.fileSize / 1024) : '- '
                }}kB)</span
              >
            </div>
          </div>
        }
      }
    </div>
  }
</ng-container>
